import { io } from 'socket.io-client';

// Initialize socket.io client
// Proxy in development is set to http://localhost:5000
const socket = io();

export default socket;